import React from 'react';

/**
 * Componente de carga elegante para Suspense boundaries
 * Se muestra mientras las páginas lazy-loaded se están cargando
 */
const PageLoader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-slate-950 dark:to-slate-900 transition-colors duration-300">
      <div className="text-center">
        {/* Spinner animado */}
        <div className="relative inline-block">
          <div className="w-16 h-16 border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin"></div>
          <div className="absolute inset-0 w-16 h-16 border-4 border-transparent border-r-purple-400 rounded-full animate-spin-slow"></div>
        </div>
        
        {/* Texto de carga */}
        <p className="mt-4 text-gray-600 dark:text-gray-300 font-medium animate-pulse">
          Cargando...
        </p>
      </div>
    </div>
  );
};

export default PageLoader;
